import { Flex, FlexProps, Heading, HeadingProps } from "@chakra-ui/react";
import React, { ReactNode } from "react";

import AnimatedSpinner from "@/common/components/AnimatedSpinner";

export type SectionHeadingProps = HeadingProps & {
  icon?: ReactNode;
  variant?: "default" | "subtle";
  isLoading?: boolean;
  rightElement?: ReactNode;
  _container?: FlexProps;
};

export function SectionHeading({
  children,
  icon,
  variant = "default",
  isLoading = false,
  rightElement,
  _container = {},
  ...props
}: SectionHeadingProps) {
  return (
    <Flex
      align="center"
      gap={4}
      justify="space-between"
      minH={variant === "subtle" ? 7 : undefined}
      width="full"
      {..._container}
    >
      <Flex alignItems="center" gap={2}>
        {icon}
        <Heading
          as="h3"
          color={variant === "subtle" ? "dimmed" : undefined}
          fontSize={variant === "subtle" ? "sm" : "md"}
          fontWeight={variant === "subtle" ? "normal" : "medium"}
          {...props}
        >
          {children}
        </Heading>
        <AnimatedSpinner show={isLoading} size="xs" variant="subtle" />
      </Flex>
      {rightElement}
    </Flex>
  );
}
